import { useSelector } from 'react-redux';
import SurveyForm from '../../components/SurveyForm/SurveyForm';
import UserSurvey from '../../components/UserSurvey/UserSurvey';
import { UPDATE_SURVEY } from '../../constants';
import { State } from '../../models/state';

interface SurveyEditProps {
  filledContent?: boolean;
}

function SurveyEdit({ filledContent }: SurveyEditProps) {
  const { user } = useSelector((state: State) => state.auth);
  if (!user.isAdmin || filledContent) {
    return <UserSurvey />;
  }
  return <SurveyForm type={UPDATE_SURVEY} />;
}

export default SurveyEdit;
